'use client';

import { FormTextarea } from '@/components/form/FormTextarea';
import { useFieldContext } from '@/lib/form/contexts';

interface TextareaFieldProps {
  label: string;
  rows?: number;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
}

export const TextareaField = ({
  label,
  rows,
  autoComplete,
  required,
  placeholder,
}: TextareaFieldProps) => {
  const field = useFieldContext<string>();
  return (
    <FormTextarea
      label={label}
      rows={rows}
      name={field.name}
      autoComplete={autoComplete}
      required={required}
      placeholder={placeholder}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={field.state.meta.errors[0]?.message}
    />
  );
};
